import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "device-mobile-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.0017 2.24634C17.5214 2.24634 18.7526 3.4775 18.7526 4.99717V19.003C18.7526 20.5227 17.5214 21.7538 16.0017 21.7538H7.99839C6.47872 21.7538 5.24756 20.5227 5.24756 19.003V4.99717C5.24756 3.4775 6.47872 2.24634 7.99839 2.24634H16.0017ZM6.74756 4.99717C6.74756 4.30592 7.30715 3.74634 7.99839 3.74634H8.74902V4.79709C8.74902 5.40842 9.18653 6.14734 9.99923 6.14734H14.0009C14.8136 6.14734 15.2511 5.40842 15.2511 4.79709V3.74634H16.0017C16.693 3.74634 17.2526 4.30592 17.2526 4.99717V19.003C17.2526 19.6943 16.693 20.2538 16.0017 20.2538H7.99839C7.30715 20.2538 6.74756 19.6943 6.74756 19.003V4.99717ZM13.7511 3.74634V4.64734H10.249V3.74634H13.7511Z"
    }, null, -1)
  ])))
}
export default { render: render }